import { Aspect } from '@teambit/harmony';

export const LanesAspect = Aspect.create({
  id: 'teambit.lanes/lanes',
});

export default LanesAspect;
